import { CSSProperties } from 'react';
import { SxProps } from '@mui/material';
import { custom2, primary, text } from 'assets/colors';

export const staticDateRangeActiveStyles = {
  background: `${custom2.text} !important`,
  color: `${primary.contrastText} !important`,
  fontWeight: 'bold !important',
  '&:hover': {
    background: `${custom2.text} !important`,
    color: `${primary.contrastText} !important`,
  },
};

export const dateRangeStyles: CSSProperties = {
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  textAlign: 'left',
  color: text.primary,
  fontWeight: 400,
};

export const staticDateRangeStyles: CSSProperties = {
  color: text.primary,
  background: primary.contrastText,
  fontSize: 12,
  textAlign: 'left',
  padding: '.45rem .4rem',
  justifyContent: 'left',
  width: '100%',
  borderRadius: 0,
};

export const iconStyle: CSSProperties = {
  fontSize: '22px',
  color: primary.main,
  marginLeft: '1px',
};

export const closeIconStyles: SxProps = {
  display: 'none',
  transition: 'all .3s ease-in-out',
  fontSize: '24px',
  borderRadius: '50%',
  padding: '4px',
  '&:hover': {
    background: primary.background,
  },
};
